module.exports = __webpack_public_path__ + "static/media/shiftDelete 2.0e031e46.svg";